var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "tree-item-wrapper" },
    [
      !_setup.isHidden
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: {
                    placement: "top",
                    interactive: false,
                    content: _setup.itemName,
                    onShow: () => _setup.showTooltip,
                  },
                  expression:
                    "{\n            placement: 'top',\n            interactive: false,\n            content: itemName,\n            onShow: () => showTooltip\n        }",
                },
              ],
              staticClass: "tree-item d-flex align-items-center px-3 py-1",
              attrs: {
                id: `treeitem-${_vm.treeItem.type}-${_vm.treeItem.uuid}-${_vm.treeItem.id}`,
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _setup.handleTreeItem()
                },
              },
            },
            [
              _c(_setup.CCheckbox, { attrs: { value: _setup.selected } }),
              _vm._v(" "),
              !_setup.isSelectAll
                ? _c("div", { staticClass: "tree-item-id text-left" }, [
                    _setup.isCanvasElement && _vm.treeItem.id
                      ? _c("span", { staticClass: "px-2 no-wrap" }, [
                          _vm._v("ID " + _vm._s(_vm.treeItem.id)),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex flex-grow-1 tree-item-text",
                  class: "level-" + _vm.marginLevel,
                },
                [
                  _vm.treeItem.icon
                    ? _c(_setup.SvgIcon, {
                        staticClass: "cursor-pointer",
                        staticStyle: {
                          "font-size": "16px",
                          color: "#89c3d1",
                          fill: "#89c3d1",
                        },
                        attrs: { src: _setup.getIcon },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "ml-2 ellipsis" }, [
                    _vm._v(_vm._s(_setup.itemName)),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _setup.hasChildren && !_setup.isSelectAll
                ? _c(
                    "div",
                    {
                      staticClass: "p-1",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          _setup.showChildren = !_setup.showChildren
                        },
                      },
                    },
                    [
                      _c("b-icon", {
                        staticStyle: { width: "16px", height: "16px" },
                        attrs: {
                          icon: _setup.showChildren
                            ? "chevron-up"
                            : "chevron-down",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _setup.hasChildren
        ? _c(
            "b-collapse",
            {
              model: {
                value: _setup.showChildren,
                callback: function ($$v) {
                  _setup.showChildren = $$v
                },
                expression: "showChildren",
              },
            },
            _vm._l(_vm.treeItem.children, function (item, index) {
              return _c("modal-import-layers-tree-item", {
                key: `tree-item-${index}`,
                attrs: {
                  "tree-item": item,
                  "margin-level": !_setup.isHidden
                    ? _setup.childrenLevel
                    : _setup.childrenLevel - 1,
                },
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_setup.hasChildren && !_setup.isCanvasElement
        ? _c("div", { staticClass: "text-center py-1" }, [
            _vm._v("No layers found"),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }